import type { DataOption } from '@/common.types'

import { map, paths, pipe, prop } from 'lodash/fp'

import { useOptimizationGroupQuery } from '@/entities/optimization-group'
import { useScenariosQuery } from '@/entities/scenario'

import { toOption } from '@/shared/tools/utils'

export const useScenariosOptions = (optimizationGroupId: string) => {
	/**
	 * Queries
	 */
	const {
		data: optimizationGroupName,
		isLoading: isOptimizationGroupNameLoading,
	} = useOptimizationGroupQuery(optimizationGroupId, {
		select: prop('name'),
	})

	const { data: scenariosOptions, isLoading: isScenariosOptionsLoading } =
		useScenariosQuery<DataOption[]>(optimizationGroupId, {
			select: pipe(map(paths(['id', 'name'])), toOption),
		})

	return {
		options: scenariosOptions || [],
		isLoading: isOptimizationGroupNameLoading || isScenariosOptionsLoading,
		optimizationGroupName: optimizationGroupName || '',
	}
}
